var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"genre-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.setGenreToStore(_vm.genre)}}},[_vm._v(" "+_vm._s(_vm.genreName)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }